import { useQuery } from '@tanstack/react-query';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { providerApi } from '../api/admin';
import { messageFromOrchestratorAxiosError } from '../lib/axiosErrorMessage';
import { AdminListPageHeader } from '../components/admin/adminListPageUi';

export function ProvidersPage() {
  const q = useQuery({ queryKey: ['providers'], queryFn: () => providerApi.list() });

  if (q.isPending) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (q.isError) {
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={() => q.refetch()}>
            Retry
          </Button>
        }
      >
        {messageFromOrchestratorAxiosError(q.error) || 'Failed to load providers.'}
      </Alert>
    );
  }

  return (
    <Box>
      <AdminListPageHeader title="Providers" subtitle="Adapter-backed providers and mapping readiness." />
      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Display name</TableCell>
              <TableCell>Adapter</TableCell>
              <TableCell>Base URL</TableCell>
              <TableCell>Mapping?</TableCell>
              <TableCell>Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(q.data ?? []).map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>
                  <RouterLink to={`/providers/${row.id}`}>{row.id}</RouterLink>
                </TableCell>
                <TableCell>{row.displayName}</TableCell>
                <TableCell>{row.adapterKind}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>
                  {row.baseUrl ?? '—'}
                </TableCell>
                <TableCell>
                  {row.responseMapping
                    ? `${Object.keys(row.responseMapping).length} fields`
                    : '—'}
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    color={row.isActive ? 'success' : 'default'}
                    label={row.isActive ? 'Active' : 'Inactive'}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
